import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import GlobalEANComponent from '../components/global-ean.component';
import { globalEANs } from '../../../../../redux/global-eans/action';
import { selectGlobalEANsQueryItems } from '../../../../../redux/global-eans/selector';

const GlobalEAN = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectGlobalEANsQueryItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [selectedGlobalEAN, setSelectedGlobalEAN] = useState<any>({
    EANs: '',
    Description: ''
  })

  const fetchGlobalEANById = () => {
    dispatch(globalEANs.query({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-eans/query`,
      entity: 'globalEANs',
      jsonData: {
        Context: {},
        Records: [
          {
            "Id": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedGlobalEAN({ ...selectedGlobalEAN, [field]: event });
  }

  useEffect(() => {
    if (parmas?.id > 0) {
      fetchGlobalEANById()
      setIsLoading(false)
    }
    else {
      setIsLoading(false)
    }
  }, []
  )

  useEffect(() => {
    if (isQuery) {
      setSelectedGlobalEAN(queryItems?.result?.items)
    }
  }, [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(globalEANs.resetAction({ actionType: 'update' }))
      await dispatch(globalEANs.update({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-eans`,
        entity: 'globalEANs',
        jsonData: {
          Context: {},
          Records: [
            {
              ...selectedGlobalEAN
            }
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(globalEANs.resetAction({ actionType: 'create' }))
      await dispatch(globalEANs.create({
        url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-eans`,
        entity: 'globalEANs',
        jsonData: {
          Context: {},
          Records: [
            {
              ...selectedGlobalEAN
            }
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate(-1)
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <GlobalEANComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedGlobalEAN={selectedGlobalEAN}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )

}

export default GlobalEAN;
